<template>
  <div class="medics">
    <h3>Pacientes</h3>
    <div class="wrapper-listado">
      <div class="listado-header">
        <div class="accion-listado">
          <div class="action">
            <i class="fas fa-plus-circle"></i>
            <router-link :to="{name:'new-patient' }">Nuevo paciente</router-link>
          </div>
        </div>
      </div>
      <div class="wrapper-body">
        <table class="table table-striped">
          <tbody>
            <tr v-for="medic in medics" v-bind:key="medic.wallet">
              <td>{{medic.name}}</td>
              <td>{{medic.wallet}}</td>
              <td class="tools">
                <router-link :to="{name: 'patient', params: { id: medic.registerAddress}}">
                  <i class="fas fa-notes-medical"></i> Ver datos
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import gun from "../managers/gun";

export default {
  data() {
    return {
      medics: []
    };
  },
  methods: {
    async refreshmedics() {
      var medics = gun.get("patients");
      if (medics != undefined) {
        medics.map().on((val, category) => {
          //  for(let medic of val) {
          //    console.log(medic)
          //  }
          console.log(category);
          console.log(val.name);
          this.medics.push(val);
        });
      }
    }
  },
  created() {
    this.refreshmedics();
  }
};
</script>
<style lang="scss" scoped>
</style>